// extracted by mini-css-extract-plugin
module.exports = {"holder":"ProjectPopup_holder__XKJHB","by":"ProjectPopup_by__3_PH0","link":"ProjectPopup_link__18EbK","name":"ProjectPopup_name__3-RqN"};